import { createAction } from '@reduxjs/toolkit';
import { tagTypes } from 'lib/src/shared/enums/tagTypes';
import { ChallengeTag } from 'lib/src/types/shared/ChallengeTag';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';

export const editTagRequest = createAction('editTagRequest');
export const editTagSuccess = createAction<ChallengeTag>('editTagSuccess');
export const editTagFailure = createAction('editTagFailure');

export const editTag = (id: number, postBody: PostBody) => async (
    dispatch: AppDispatch,
): Promise<void> => {
    dispatch(editTagRequest());
    try {
        const { data } = await api.patch<PostBody, ChallengeTag>(
            `admin/challengeTags/${id}`,
            postBody,
        );

        dispatch(editTagSuccess(data));
    } catch (e: any) {
        handleApiErrors(dispatch, editTagFailure, e);
    }
};

type PostBody = {
    name: string;
    isPublic: boolean;
    type: tagTypes;
};
